"use client";

import * as React from "react";

import { useCarousel } from "@/components/carousel/useCarousel";
import { cn } from "@/utils/cn";

export const CarouselContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const { carouselRef, orientation } = useCarousel();

  return (
    <div ref={carouselRef} className={className}>
      <div
        ref={ref}
        className={cn(
          "flex",
          orientation === "horizontal" ? "-ml-16" : "-mt-16 flex-col"
        )}
        {...props}
      />
    </div>
  );
});
CarouselContent.displayName = "CarouselContent";
